import getBaseStyles from './styles';

export default /* istanbul ignore next */ (theme) => {
  const baseStyles = getBaseStyles(theme);

  return {
    ...baseStyles,
    content: {
      ...baseStyles.content,
      flexGrow: 1,
    },
    pictureContainer: {
      ...baseStyles.pictureContainer,
      minWidth: 270,
      minHeight: 180,
    },
    text: {
      marginBottom: theme.spacing(2),
    },
  };
};
